



















import { Component, namespace, mixins, Watch } from 'nuxt-property-decorator'
import { STORES_API } from '~/assets/config/api-path'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { IMeta } from '~/assets/interfaces/meta'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'
import { IImageVariants } from '~/assets/interfaces/images'
import ComponentStoresItem from '~/components/stores/stores-item.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import { Map, ObjectManager, Placemark } from '~/assets/shims/ymaps'

const pageStore = namespace('page')
const siteStore = namespace('site')

interface IStoreItem {
  id: number
  address: string
  title: string
  phone: string
  time: string
  url: string
  email: string
  image?: IImageVariants
  lat: number
  lon: number
}

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentPageContent,
    ComponentTypographyH1,
    ComponentStoresItem,
  },
})
export default class pageNews extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
  }) {
    const response = await $axios.$get(filterUrl(STORES_API))

    return response
  }

  @siteStore.Getter('getApiKeyYandexMap') private getApiKeyYandexMap!:
    | string
    | null

  private items: IStoreItem[] = []

  private get hideImageColumn() {
    return !this.items.some((e: IStoreItem) => !!e.image)
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  @Watch('ymapsScriptLoaded')
  private OnYmapsScriptLoadedChange(val: boolean) {
    if (val) {
      this.ymapsReady()
    }
  }

  private mounted() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://api-maps.yandex.ru/2.1/?apikey=' +
      this.getApiKeyYandexMap +
      '&lang=ru_RU&onload=pageStoreItemYmapsInit'

    document.getElementsByTagName('head')[0].appendChild(script)
    window.pageStoreItemYmapsInit = this.pageStoreItemYmapsInit
  }

  private pageStoreItemYmapsInit() {
    this.ymapsScriptLoaded = true
  }

  private isMapLoaded = false

  private YandexMap: Map | null = null

  private ymapsDestroy() {
    if (this.YandexMap) {
      this.YandexMap.destroy()
      this.YandexMap = null
    }
    if (this.$refs.map) {
      ;(this.$refs.map as HTMLElement).innerHTML = ''
    }
  }

  private ymapsScriptLoaded = false

  private ymapsReady() {
    if (this.ymapsScriptLoaded) {
      ymaps.ready(async () => {
        if (this.YandexMap) {
          this.ymapsDestroy()
        }
        this.YandexMap = new ymaps.Map('map', {
          controls: ['zoomControl', 'geolocationControl'],
          center: [55.76, 37.64],
          zoom: 7,
        })
        this.isMapLoaded = true

        await this.ymapsGeoObjectsInsert()
      })
    }
  }

  private clusterer: ObjectManager | null = null

  private async ymapsGeoObjectsInsert() {
    if (this.YandexMap) {
      this.YandexMap.geoObjects.removeAll()
      this.clusterer = new ymaps.Clusterer()

      const geoObjects: Placemark[] = []

      this.items.forEach((item) => {
        geoObjects.push(
          new ymaps.Placemark(
            [item.lon, item.lat],
            {
              hintContent: item.title,
              balloonContentHeader: item.title,
              balloonContent: `
        <div style="padding:10px 0; max-width:250px;">
          ${item.address}<br/>
          ${item.phone ? 'Тел: ' + item.phone + '<br/>' : ''}
          ${item.time ? 'Время: ' + item.time : ''}
        </div>
      `,
            },
            {
              iconLayout: 'default#image',
              iconImageHref: require('@/assets/images/ext/pin.svg'),
              iconImageSize: [30, 40],
              iconImageOffset: [-15, -40],
            }
          )
        )
      })

      if (this.clusterer) {
        this.clusterer.add(geoObjects)
        this.YandexMap.geoObjects.add(this.clusterer) // eslint-disable-line
        const bounds: number[][] | null = this.YandexMap.geoObjects.getBounds()

        if (bounds !== null) {
          await this.YandexMap.setBounds(bounds, {
            checkZoomRange: true,
            zoomMargin: [64, 128],
          })

          if (this.YandexMap.getZoom() > 16) {
            await this.YandexMap.setZoom(16)
          }
        }
      }
    }
  }

  private created(): void {
    this.setMeta({
      title: 'Наши магазины',
      h1: 'Наши магазины',
    })
  }
}
